import * as React from 'react'
import type { SVGProps } from 'react'

type AccessibleIconProps = SVGProps<SVGSVGElement> & {
  Icon: React.ComponentType<any>
  label?: string
  decorative?: boolean
  className?: string
  color?: string
}

export function AccessibleIcon({
  Icon,
  label,
  decorative = false,
  className,
  color,
  ...rest
}: AccessibleIconProps) {
  const hasLabel = typeof label === 'string' && label.length > 0

  if (decorative || !hasLabel) {
    return <Icon aria-hidden="true" focusable={false} className={className} color={color} {...rest} />
  }

  const titleId = `icon-${Math.random().toString(36).slice(2, 9)}`

  return (
    <Icon role="img" aria-labelledby={titleId} className={className} color={color} {...rest}>
      <title id={titleId}>{label}</title>
    </Icon>
  )
}

export default AccessibleIcon
